module.exports = __webpack_public_path__ + "static/media/floor-safes.aabf45d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/floor-safes.png
// module id = 1289
// module chunks = 0